/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as moment from 'moment';

@Component({
  selector: 'app-time-picker',
  templateUrl: './time-picker.component.html',
  styleUrls: ['./time-picker.component.scss'],
})
export class TimePickerComponent implements OnInit {
  form: FormGroup;
  @Input() FormControl: AbstractControl; // нарочно е с голяма буква, бърка го иначе
  @Output() select = new EventEmitter();

  constructor(private formBuilder: FormBuilder) {}

  ngOnInit() {
    this.form = this.formBuilder.group({
      time_fake: ['', [Validators.required]],
    });

    if (this.FormControl.value && this.FormControl.value.length > 0) {
      // дата-та тук е фиктивна колкото да парсне moment-а
      this.form.get('time_fake').setValue(moment('01.01.2010 ' + this.FormControl.value).format('HH:mm'));
    }
    this.FormControl.valueChanges.subscribe((val) => {
      // дата-та тук е фиктивна колкото да парсне moment-а
      this.form.get('time_fake').setValue(moment('01.01.2010 ' + this.FormControl.value).format('HH:mm'));
    });
  }

  onSelect() {
    const date = moment(this.form.get('time_fake').value).format('HH:mm');
    this.FormControl.setValue(date);

    // Праща time-a към parent-елемента.
    // Когато се вика директивата може да се закачи "(onSelect)" event
    this.select.emit(date);
  }

  /**
   * Когато пипше проверява дали е налисан валиден час.
   * При написан валиден час сетва стойността и в истинския инпут.
   * При написан невалиден час сетва null в истинския инпут.
   * Налага се ръчно обновяване на валидатора и  emitEvent: false, защото иначе зацикля.
   */
  onType() {
    if (moment(this.form.get('time_fake').value).isValid()) {
      this.onSelect();
    } else {
      this.FormControl.setValue(null, { emitEvent: false });
      this.select.emit(null);
      this.FormControl.setErrors({ invalid: true });
    }
  }
}
